import FormControl from "../../../MUI_components/FormControl/fomikFormControl";
import { FieldArray } from "formik";
import React, { useEffect, useState } from "react";
import {
  Button,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { currency } from "../../../MUI_components/currencyFormatterTag";
import { Delete } from "@mui/icons-material";
import { COLUMNS_NAME } from "Components/Constants/ColumnsNames";
import { SYSTEM_EDITIONS } from "Components/Constants/SystemEditions";
import { System } from "titum-custom/details";
import { PAYMENT_TYPE } from "Components/Constants/PaymentType";
import { DEFAULT_VALUES } from "Components/Constants/defaultValues";
import { openSnackbar } from "Redux/Actions/snackbarActions";
import SalesReturnService from "Service/Invoice/SalesReturn.service";

export default function Payments(props: any) {
  const { billTotal,
    isValid, 
    onSubmit,
     setPrintType, 
     customer,
     returnTotal,
     setReturnTotal,
     balaceWithReturn,
     invoiceValue,
     setInvoiceValue,
     setReturnCode,
     returnCode
   
   } = props;
  const banks = useSelector((state: any) => state.bank);
  const paymentTypes = useSelector((state: any) => state.paymentType);
  const [loading,setLoading] = useState(false);

  const today = new Date().toISOString().split("T")[0];
  const [cardFee, setCardFee] = useState(0);
  const dispatch = useDispatch();

  const [initPayment, setInitPayment] = useState({
    amount: "",
    paidStatus: 0,
    paymentType: "",
    remarks: "",
    bankDeposit: {
      date: "",
      refNumber: "",
      bank: "",
    },
    chequePayment: {
      chequeDate: "",
      bank: "",
      chequeNumber: "",
    },
    cardPayment: {
      refNumber: "",
      cardNumber: "",
      bank: "",
      cardFee: cardFee
    },
    onlineTransfer: {
      transferDate: "",
      bank: "",
      transferId: "",
    },
  });

  const handleReturnAmount = async () => {
    try {
      setLoading(true);
  
      const res = await SalesReturnService.get(returnCode);
  
      if (!res) {
        alert("Please Enter Valid Sales Return Code");
        setLoading(false);
        setReturnCode("");
        return;
      }
  
      if (res.isSetteled == true) {
        alert("This sales return has already been used for a settled invoice.");
        setReturnCode("");
        setLoading(false);
      } else {
        setReturnTotal(res.totalAmount);
      }
  
    } catch (e) {
      dispatch(openSnackbar(true, "error", e));
      setLoading(false); // Ensure loading state is reset in case of an error
    }
  };

  return (
    <FieldArray name="payment">
      {(fieldArrayProps) => {
        const { form } = fieldArrayProps;
        const { values, isSubmitting, setFieldValue } = form;

        const paymentWithoutReturn = values.modeOfPayments
        .map((payment: any) => payment.amount)
        .reduce((sum: any, i: any) => sum + i, 0);

        const  paymentTotal = paymentWithoutReturn + parseFloat(returnTotal);

        const totalwithoutCard = values.modeOfPayments.filter((row: any) =>
          (!row.cardPayment.refNumber && !row.cardPayment.cardNumber && !row.cardPayment.bank)).map((elem: any) => elem.amount).reduce((acc: any, sum: any) => (acc + sum), 0);

        let paymentByCard = billTotal - totalwithoutCard - returnTotal;

        const billTotalWithCardPayment = billTotal + paymentByCard * DEFAULT_VALUES.CARD_PAYMENT / 100;
        let cardFee = paymentByCard * DEFAULT_VALUES.CARD_PAYMENT / 100;
        setCardFee(cardFee);

        return (
          <>
           <div className="row" >
            <div className="col-9">
            <TextField
                fullWidth
                variant="outlined"
                label="Sales Return Code"
                value={returnCode}
                onChange={(e:any)=>setReturnCode(e.target.value)}
              />
            </div>
            <div className="col-3">
              <Button 
                variant="contained"
                color="primary"
                onClick={handleReturnAmount} 
                disabled={loading || !returnCode}
              >
                Return Amount
              </Button>
            </div>
       
          </div>
            <div className="row" style={{ marginTop: 20, marginBottom: 20 }}>
              {values.payment.paymentType && values.payment.paymentType ===
                paymentTypes.filter(
                  (paymentType: any) => paymentType.name === "Card"
                )[0]["code"] && (
                  <div style={{ color: 'red' }}>With Card Payment : {currency(paymentByCard + (paymentByCard * 3.2 / 100))} </div>
                )}
               <div className="col-12">
                <TextField
                  variant="standard"
                  fullWidth
                  label="Bill Total"
                  value={currency(billTotal)}
                  disabled
                />
              </div>
              <div className="col-12">
                <TextField
                  variant="standard"
                  fullWidth
                  label="Return Total"
                  value={currency(returnTotal)}
                  disabled
                />
              </div>
              <div className="col-12">
                <TextField
                  variant="standard"
                  fullWidth
                  label="Balance"
                  value={balaceWithReturn}
                  disabled
                />
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <FormControl
                  control="select"
                  label="Payment Type"
                  options={paymentTypes}
                  name="payment.paymentType"
                />
              </div>
              <div className="col-6">
                <FormControl
                  control="currency"
                  nested
                  name="payment.amount"
                  label={`Paid Amount ${values.payment.paymentType ==
                    paymentTypes.filter(
                      (paymentType: any) => paymentType.name == PAYMENT_TYPE.OVER_PAYMENT
                    )[0]["code"] ? values.customer?.overPayment : values.payment.paymentType ==
                      paymentTypes.filter(
                        (paymentType: any) => paymentType.name == PAYMENT_TYPE.RETURN_AMOUNT
                      )[0]["code"] ? values.customer?.returnAmount :
                      ""}`}
                />
              </div>
            </div>
            {values.payment.paymentType && (
              <>
                {values.payment.paymentType ===
                  paymentTypes.filter(
                    (paymentType: any) => paymentType.name === "Cheque"
                  )[0]["code"] && (
                    <FieldArray name="payment.chequePayment">
                      {(chequePaymentProps) => {
                        return (
                          <div className="row">
                            <div className="col-4">
                              <FormControl
                                control="select"
                                label="Bank"
                                options={banks}
                                name="payment.chequePayment.bank"
                              />
                            </div>
                            <div className="col-4">
                              <FormControl
                                control="input"
                                label="Cheque Number"
                                name="payment.chequePayment.chequeNumber"
                              />
                            </div>
                            <div className="col-4">
                              <FormControl
                                control="input"
                                type="date"
                                label="Cheque Date"
                                name="payment.chequePayment.date"
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                inputProps={{
                                  min: today,
                                }}
                              />
                            </div>
                          </div>
                        );
                      }}
                    </FieldArray>
                  )}
                {values.payment.paymentType ===
                  paymentTypes.filter(
                    (paymentType: any) => paymentType.name === "Bank Deposit"
                  )[0]["code"] && (
                    <FieldArray name="payment.bankDeposit">
                      {(bankDepositProps) => {
                        return (
                          <div className="row">
                            <div className="col-4">
                              <FormControl
                                control="select"
                                label="Bank"
                                options={banks}
                                name="payment.bankDeposit.bank"
                              />
                            </div>
                            <div className="col-4">
                              <FormControl
                                control="input"
                                label="Ref Number"
                                name="payment.bankDeposit.refNumber"
                              />
                            </div>
                            <div className="col-4">
                              <FormControl
                                control="input"
                                name="payment.bankDeposit.date"
                                label="Deposited Date"
                                type="date"
                                InputLabelProps={{
                                  shrink: true,
                                }}
                              />
                            </div>
                          </div>
                        );
                      }}
                    </FieldArray>
                  )}
                {values.payment.paymentType ===
                  paymentTypes.filter(
                    (paymentType: any) => paymentType.name === "Card"
                  )[0]["code"] && (
                    <FieldArray name="payment.cardPayment">
                      {(cardPaymentProps) => {
                        return (
                          <>
                            <div className="row">
                              <div className="col-4">
                                <FormControl
                                  control="select"
                                  label="Bank"
                                  options={banks}
                                  name="payment.cardPayment.bank"
                                />
                              </div>
                              <div className="col-4">
                                <FormControl
                                  control="input"
                                  label="Ref Number"
                                  name="payment.cardPayment.refNumber"
                                />
                              </div>
                              <div className="col-4">
                                <FormControl
                                  control="number"
                                  label="Card Number (Last 4 digit)"
                                  name="payment.cardPayment.cardNumber"
                                />
                              </div>
                            </div>
                          </>
                        );
                      }}
                    </FieldArray>
                  )}
                {values.payment.paymentType ===
                  paymentTypes.filter(
                    (paymentType: any) =>
                      paymentType.name === "Online Transfer"
                  )[0]["code"] && (
                    <FieldArray name="payment.onlineTransfer">
                      {() => {
                        return (
                          <>
                            <div className="row">
                              <div className="col-4">
                                <FormControl
                                  control="select"
                                  label="Bank"
                                  options={banks}
                                  name="payment.onlineTransfer.bank"
                                  required
                                // onChange={handleDataChange}
                                />
                              </div>
                              <div className="col-4">
                                <FormControl
                                  control="input"
                                  label="Transfer Id"
                                  name="payment.onlineTransfer.transferId"
                                />
                              </div>
                              <div className="col-4">
                                <FormControl
                                  control="input"
                                  name="payment.onlineTransfer.transferDate"
                                  label="Transfer Date"
                                  type="date"
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                />
                              </div>
                            </div>
                          </>
                        );
                      }}
                    </FieldArray>
                  )}
              </>
            )}
            <div className="row">
              <div className="col-12">
                <FormControl
                  control="input"
                  name="payment.remarks"
                  label="Remarks"
                />
              </div>
            </div>
            <FieldArray name="modeOfPayments">
              {({ push, remove }) => (
                <>
                  <div className="row flex-end mb">
                    <Button
                    disabled={
                      !values.payment.amount ||
                      !values.payment.paymentType ||
                      (values.payment.paymentType == 21910000002 &&
                        (!values.payment.chequePayment.bank ||
                          !values.payment.chequePayment.chequeNumber ||
                          !values.payment.chequePayment.date)) ||
                      (values.payment.paymentType == 21910000003 &&
                        (!values.payment.bankDeposit.bank ||
                          !values.payment.bankDeposit.refNumber ||
                          !values.payment.bankDeposit.date)) ||
                      (values.payment.paymentType == 21910000004 &&
                        (!values.payment.cardPayment.bank ||
                          !values.payment.cardPayment.refNumber ||
                          !values.payment.cardPayment.cardNumber)) ||
                      (values.payment.paymentType == 21910000007 &&
                        (!values.payment.onlineTransfer.bank ||
                          !values.payment.onlineTransfer.transferId ||
                          !values.payment.onlineTransfer.transferDate))
                    }
                      variant="contained"
                      onClick={() => {
                        if ((values.payment.paymentType ==
                          paymentTypes.filter(
                            (paymentType: any) => paymentType.name == PAYMENT_TYPE.OVER_PAYMENT
                          )[0]["code"]) && values.payment.amount > values.customer.overPayment
                        ) {
                          alert("The value entered is greater than available amount");
                          return;
                        } else if ((values.payment.paymentType ==
                          paymentTypes.filter(
                            (paymentType: any) => paymentType.name == PAYMENT_TYPE.OVER_PAYMENT
                          )[0]["code"]) && values.payment.amount <= values.customer.overPayment
                        ) {
                          values.customer.overPayment = values.customer.overPayment - values.payment.amount
                        }

                        if ((values.payment.paymentType ==
                          paymentTypes.filter(
                            (paymentType: any) => paymentType.name == PAYMENT_TYPE.RETURN_AMOUNT
                          )[0]["code"]) && values.payment.amount > values.customer.returnAmount
                        ) {
                          alert("The value entered is greater than available amount");
                          return;
                        }
                        else if ((values.payment.paymentType ==
                          paymentTypes.filter(
                            (paymentType: any) => paymentType.name == PAYMENT_TYPE.RETURN_AMOUNT
                          )[0]["code"]) && values.payment.amount <= values.customer.returnAmount
                        ) {
                          values.customer.returnAmount = values.customer.returnAmount - values.payment.amount
                        }
                        push({
                          ...values.payment,
                        });
                        setFieldValue("payment", initPayment);
                        setFieldValue("payment.amount", "");
                        setFieldValue("payment.remarks", "");
                      }}
                      color="secondary"
                    >
                      Add
                    </Button>
                  </div>
                  <div className="row">
                    <TableContainer>
                      <Table
                        aria-labelledby="tableTitle"
                        size={"small"}
                        aria-label="enhanced table"
                      >
                        <TableHead style={{ backgroundColor: "#eee" }}>
                          <TableRow hover role="checkbox" tabIndex={-1}>
                            <TableCell width={10}></TableCell>
                            <TableCell>#</TableCell>
                            <TableCell>{COLUMNS_NAME.REMARKS}</TableCell>
                            <TableCell>{COLUMNS_NAME.PAYEMENT_TYPE}</TableCell>
                            <TableCell align="right">{COLUMNS_NAME.SETTELED_AMOUNT}</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {values.modeOfPayments.map(
                            (payment: any, index: any) => (
                              <TableRow
                                role="checkbox"
                                tabIndex={-1}
                                key={index}
                              >
                                <TableCell width={10}>
                                  <Delete
                                    color="secondary"
                                    style={{
                                      fontSize: 18,
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      if (
                                        window.confirm(
                                          "Are you sure want to delete this?"
                                        )
                                      ) {
                                        remove(index);
                                      }
                                    }}
                                  />
                                </TableCell>
                                <TableCell width={10}>{index + 1}</TableCell>
                                <TableCell>{payment.remarks}</TableCell>
                                <TableCell>
                                  {
                                    paymentTypes.filter(
                                      (paymentType: any) =>
                                        paymentType.code === payment.paymentType
                                    )[0]["name"]
                                  }
                                </TableCell>
                                <TableCell align="right">
                                  {currency(payment.amount)}
                                </TableCell>
                              </TableRow>
                            )
                          )}
                          {!values.modeOfPayments.length ? (
                            <TableRow>
                              <TableCell colSpan={5} align="center">
                                No items to display
                              </TableCell>
                            </TableRow>
                          ) : (
                            <TableRow>
                              <TableCell colSpan={3} />
                              <TableCell align="left">
                                <strong>Total</strong>
                              </TableCell>
                              <TableCell align="right">
                                <strong>{currency(paymentTotal)}</strong>
                              </TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </div>
                </>
              )}
            </FieldArray>
            {System.SYSTEM_EDITION === SYSTEM_EDITIONS.BIZ_X_AUTO_CARE ? (
              <div className="flex" style={{ margin: 20 }}>
                <button
                  type="button"
                  disabled={
                    isSubmitting || !values.modeOfPayments.length || billTotalWithCardPayment < billTotalWithCardPayment
                  }
                  onClick={() => {
                    setPrintType('DOT');
                    onSubmit();
                  }}
                  className="btn-success button"
                >
                  PrintBill
                  <span>
                    {isSubmitting ? (
                      <CircularProgress
                        color="inherit"
                        size={20}
                      />
                    ) : (
                      ""
                    )}
                  </span>
                </button>
              </div>
            ) : (
              <div className="flex" style={{ margin: 20 }}>
                <button
                  type="button"
                  disabled={isSubmitting || billTotalWithCardPayment < paymentTotal || billTotalWithCardPayment > paymentTotal }
                  onClick={() => {
                    setPrintType('POS');
                    onSubmit();
                  }}
                  className="btn-success button"
                >
                  pos bill
                  <span>
                    {isSubmitting ? (
                      <CircularProgress
                        color="inherit"
                        size={20}
                      />
                    ) : (
                      "[ Enter ]"
                    )}
                  </span>
                </button>
                <button
                  type="button"
                  // disabled={
                  //   isSubmitting  || billTotalWithCardPayment < paymentTotal ||
                  //   billTotalWithCardPayment < paymentTotal
                  // }
                  disabled={isSubmitting || billTotalWithCardPayment < paymentTotal || billTotalWithCardPayment > paymentTotal }
                  onClick={() => {
                    setPrintType('DOT');
                    onSubmit();
                  }}
                  className="btn-success button"
                >
                  Dot matrix bill
                  <span>
                    {isSubmitting ? (
                      <CircularProgress
                        color="inherit"
                        size={20}
                      />
                    ) : (
                      ""
                    )}
                  </span>
                </button>
              </div>
            )}
          </>
        );
      }}
    </FieldArray>
  );
}
